import { useAuth } from './auth/AuthContext'

/** Classification level color mapping (ICD 710 / DoDM 5200.01). */
const LEVEL_COLORS: Record<string, { bg: string; text: string }> = {
  CUI: { bg: 'bg-purple-700', text: 'text-white' },
  CONFIDENTIAL: { bg: 'bg-blue-700', text: 'text-white' },
  SECRET: { bg: 'bg-red-700', text: 'text-white' },
  TOP_SECRET: { bg: 'bg-orange-500', text: 'text-black' },
  TS_SCI: { bg: 'bg-yellow-400', text: 'text-black' },
}

/**
 * Classification banner for the application shell (ADR-0054 Decision 12).
 *
 * Renders nothing for UNCLASSIFIED — no marking requirement exists for
 * unclassified environments, keeping the UI clean for commercial deployments.
 *
 * For CUI and above: renders a full-width bar per DoD classification
 * marking requirements (ICD 710 / DoDM 5200.01).
 */
export function ClassificationShellBanner() {
  const { user } = useAuth()

  const level = user?.classification?.level ?? 'UNCLASSIFIED'
  const caveats = user?.classification?.caveats ?? []

  // UNCLASSIFIED: no banner — no marking requirement, clean UI for commercial use
  if (level.toUpperCase() === 'UNCLASSIFIED') {
    return null
  }

  const colors = LEVEL_COLORS[level.toUpperCase()] ?? { bg: 'bg-gray-700', text: 'text-white' }
  const displayText = caveats.length > 0 ? `${level}//${caveats.join('/')}` : level

  return (
    <div
      className={`${colors.bg} ${colors.text} text-center text-xs font-bold py-0.5 tracking-widest select-none`}
    >
      {displayText}
    </div>
  )
}
